export default "__VITE_ASSET__BLKYs9bC__"